import { useContext, type ReactNode } from "react";
import { Link } from "react-router-dom";

import { useCartPanelMounted } from "@/components/ecomm/cartPanelPresence";
import { CartContext } from "@/contexts/cartContext";

export const CARD_BUTTON_CLASSES =
  "unset h-[40px] px-[var(--chat-space-05)] border border-[var(--chat-black)] rounded-[var(--chat-corner-sm)] text-[13px] font-semibold text-[var(--chat-black)] disabled:opacity-50 disabled:cursor-not-allowed focus-visible:outline focus-visible:outline-2";

/** Opens the cart panel; on a page without one, links to Shop Care, whose header opens it.
 * The plan card's ADDED! bar restyles it with its own label, content and classes. */
export default function ChatViewCart({
  label,
  className,
  children = "View cart",
}: {
  label?: string;
  className?: string;
  children?: ReactNode;
}) {
  const { setShowCart, refetchCart } = useContext(CartContext);
  const hasCartPanel = useCartPanelMounted();
  const openCart = (): void => {
    refetchCart();
    setShowCart(true);
  };
  return hasCartPanel ? (
    <button
      type="button"
      onClick={openCart}
      aria-label={label}
      className={className ?? CARD_BUTTON_CLASSES}
    >
      {children}
    </button>
  ) : (
    <Link
      to="/care/"
      onClick={openCart}
      aria-label={label}
      className={
        className ??
        "text-[13px] font-semibold text-[var(--chat-black)] underline"
      }
    >
      {children}
    </Link>
  );
}
